const LOGO_URL = '/icons/moss-logo-v2.svg'
const RESOLUTION_SCALE = 4

export type Logo = {
  dataUrl: string
  width: number
  height: number
}

export const loadLogo = async (): Promise<Logo> => {
  const image = new Image()

  image.src = LOGO_URL
  await image.decode()

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  if (!context) {
    throw new Error('Canvas is not available to draw the logo')
  }

  canvas.width = image.naturalWidth * RESOLUTION_SCALE
  canvas.height = image.naturalHeight * RESOLUTION_SCALE
  context.drawImage(image, 0, 0, canvas.width, canvas.height)

  return {dataUrl: canvas.toDataURL('image/png'), width: image.naturalWidth, height: image.naturalHeight}
}
